import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import { Grid, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

class ThreeInRow extends Component {
    constructor(props){
        super(props);
    }
    render(){
        const { players, tierIndex, classes, numPlayer, changeTier, currentTier } = this.props.props;
        const currentNumPlayer = numPlayer[tierIndex];
        let row = Math.ceil(numPlayer[tierIndex]/3)
        return (
            Array(3*row).fill(0).map((_, i) => {
                const full = players[i];
                return (
                    <React.Fragment key={i}>
                        {
                            i < currentNumPlayer ?
                            <Grid item xs={3} key={`full${i}`} className={classes.tierGrid}>
                                <Button variant={full?"contained":"outlined"} className={full?classes.tierFull:classes.tierButton} onClick={() => changeTier(tierIndex)}>
                                    {full ? full.option_name : `Tier ${tierIndex+1} Player ${i+1}`}
                                </Button>
                            </Grid>
                            :
                            <></>
                        }
                        {
                            i == 2 ?
                            <Grid item xs={3} key={`arrow${i}`} className={classes.tierGrid}>
                            {currentTier == tierIndex ? <ArrowBackIcon className={classes.tierArrow} /> : <></>}
                            </Grid>
                            :
                            <></>
                        }
                        {
                            i >= currentNumPlayer ?
                            <Grid item xs={3} key={`empty${i}`} className={classes.tierGrid}></Grid>
                            :
                            <></>
                        }
                    </React.Fragment>
                )
            })
        )
    }
}

class TwoInRow extends Component {
    constructor(props){
        super(props);
    }
    render(){
        const { players, tierIndex, classes, numPlayer, changeTier, currentTier } = this.props.props;
        const currentNumPlayer = numPlayer[tierIndex];
        let row = Math.ceil(numPlayer[tierIndex]/2)
        return (
            Array(2*row).fill(0).map((_, i) => {
                const full = players[i];
                return (
                    <React.Fragment key={i}>
                        {
                            i < currentNumPlayer ?
                            <Grid item xs={4} key={`full${i}`}>
                                <Button variant={full?"contained":"outlined"} className={full?classes.tierFull:classes.tierButton} onClick={() => changeTier(tierIndex)}>
                                    {full ? full.option_name : `Tier ${tierIndex+1} Player ${i+1}`}
                                </Button>
                            </Grid>
                            :
                            <></>
                        }
                        {
                            i == 1 ?
                            <Grid item xs={4} key={`arrow${i}`}>
                            {currentTier == tierIndex ? <ArrowBackIcon className={classes.tierArrow} /> : <></>}
                            </Grid>
                            :
                            <></>
                        }
                        {
                            i >= currentNumPlayer ?
                            <Grid item xs={4} key={`empty${i}`}></Grid>
                            :
                            <></>
                        }
                    </React.Fragment>
                )
            })
        )
    }
}

class Tier extends Component {
    constructor(props){
        super(props);
    }

    render(){
        const { numPlayer } = this.props;
        let max = Math.max(...numPlayer);
        return (
                max == 3 ?
                <ThreeInRow props={this.props} />
                :
                <TwoInRow props={this.props} />
        )
    }
}

export default withStyles(useStyles)(Tier);